import { links, Request } from '@app/client';

import { apiReturnResults } from '../../../apiFactory/apiReturn';
import {
    type ApiResult,
    type BaseParams,
    type CallParams,
    type Competition,
    type PatchParams,
    type ResourceId,
    type Winner,
} from '../../../common/structs';

export type UpdateWinner = { user_id?: ResourceId; reason?: Winner['reason']; team_id?: ResourceId };
type GetCompetitionWinnerParams = BaseParams & { slug: string };
type UpdateWinnerParams = CallParams<PatchParams<UpdateWinner> & { slug: string; winnerId: ResourceId }>;
export async function list(params: GetCompetitionWinnerParams): Promise<ApiResult<Competition['winners']>> {
    return Request.getRequest<Competition['winners']>({
        ...params,
        target: links.admin().competitions.single(params.slug).winners(),
    });
}

export async function updateWinner(params: UpdateWinnerParams): Promise<ApiResult<Winner>> {
    return Request.patchRequest<Winner>({
        ...params,
        target: links.admin().competitions.single(params.slug).updateWinner(params.winnerId),
        settings: {
            ...params.settings,
        },
    });
}
export const callGetCompetitionWinners = (params: GetCompetitionWinnerParams) =>
    apiReturnResults<Competition['winners']>(list, params);

export const callUpdateCompetitionWinners = (params: UpdateWinnerParams) =>
    apiReturnResults<Winner>(updateWinner, params);
